import { InfoIcon } from 'assets/icons';
import styles from './index.module.css';

export const BloodVisionInfoModal = () => {
  return (
    <div className={`${styles.infoModalContainer} u-hide-scrollbar`}>
      <div className={styles.infoModalTitle}>
        <h3>Testing Locations</h3>
        <p>
          Depending on your preference, choose between two convenient testing
          options:
        </p>
      </div>
      <div className={styles.infoModalDescription}>
        <h3>At Home </h3>
        <p className="description">
          Experience the convenience of getting your blood drawn from the
          comfort of your home. A licensed phlebotomist will visit you at your
          scheduled time to collect your samples.
        </p>
        <div className={styles.infoTextContainer}>
          <InfoIcon
            style={{
              width: '1.6rem',
              height: 'auto',
              marginTop: '1px',
            }}
            fill="#000"
          />
          <p className={styles.infoText}>
            Please note that this option comes with an additional fee of $75.
          </p>
        </div>
        <hr className={styles.divider} />
        <h3>At Center </h3>
        <p className="description">
          If you prefer visiting a lab, you can opt for a test at Quest
          Diagnostics or BioReference. In New York, simply select a lab and
          either walk in or call ahead to book your test. For all other regions
          in the U.S., you&apos;ll need to schedule your appointment in advance
          through the app before heading to the lab.
        </p>
      </div>

      <p className={styles.supportText}>
        Need help? Reach out anytime at
        <br />
        <a href="mailto:support@ultrahuman.com">
          <span>support@ultrahuman.com</span>
        </a>{' '}
        — we&apos;ve got your back.
      </p>
    </div>
  );
};

export const BloodVisionExperienceModal = () => (
  <div className={styles.pricingModal}>
    <BloodVisionInfoModal />
  </div>
);
